import {configureStore} from '@reduxjs/toolkit';
import headerReducer from '../slices/headerSlice';
import topicReducer from '../slices/topicSlice';
import explainerReducer from '../slices/explainerSlice';

export const store = configureStore({
    reducer: {
        header: headerReducer,
        topic: topicReducer,
        explainer: explainerReducer,
    }
});